import PlatformError from "../PlatformError";

export default new PlatformError(
  "ERROR",
  "Browser not allowed.",
  "Screenout",
  "Browser not allowed",
  "app.error.browsernotallowed"
);
